"use client";

import { FC, ReactNode } from "react";

interface BFLToggleButtonProps {
  active?: boolean;
  children: ReactNode;
  onClick: (value: any) => void;
}

const BFLToggleButton: FC<BFLToggleButtonProps> = ({
  active,
  children,
  onClick,
}) => {
  const defaultClass =
    "text-sm px-2 py-[5px] h-8 rounded-lg border border-bfl-blue cursor-pointer";
  const activeClass = `${defaultClass} text-white bg-bfl-blue`;
  return (
    <button className={active ? activeClass : defaultClass} onClick={onClick}>
      {children}
    </button>
  );
};

export default BFLToggleButton;
